import { observer } from 'mobx-react-lite';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { errorModalStore } from '@/stores/errorModal.store';

export const ErrorModal = observer(() => (
  <AnimatePresence>
    {errorModalStore.message && (
      <div className='fixed inset-0 z-50 flex items-center justify-center p-4'>
        <motion.div
          key='overlay'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.18 }}
          className='absolute inset-0 bg-black/60 backdrop-blur-sm'
          onClick={errorModalStore.dismiss}
        />
        <motion.div
          key='modal'
          initial={{ opacity: 0, scale: 0.94, y: 12 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.94, y: 8 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
          className='relative w-full max-w-sm rounded-2xl border border-border/50 bg-card shadow-2xl overflow-hidden'
        >
          <div className='absolute top-4 right-4'>
            <Button
              variant='ghost'
              size='icon'
              onClick={errorModalStore.dismiss}
              className='size-8 rounded-lg text-muted-foreground hover:bg-muted/60 hover:text-foreground'
            >
              <X className='w-4 h-4' />
            </Button>
          </div>

          <div className='flex flex-col items-center text-center px-8 pt-10 pb-6 gap-4'>
            <div className='flex items-center justify-center w-14 h-14 rounded-full bg-destructive/10'>
              <AlertTriangle className='w-7 h-7 text-destructive' />
            </div>
            <div className='flex flex-col gap-1.5'>
              <h3 className='text-base font-normal tracking-widest text-foreground'>Ошибка</h3>
              <p className='text-sm text-muted-foreground leading-relaxed'>
                {errorModalStore.message}
              </p>
            </div>
          </div>

          <div className='px-6 pb-6'>
            <Button variant='outline' className='w-full' onClick={errorModalStore.dismiss}>
              Закрыть
            </Button>
          </div>
        </motion.div>
      </div>
    )}
  </AnimatePresence>
));
